import React, { useRef } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

// Zona para seleccionar un archivo PDF (borde punteado).
// Si se ha seleccionado un archivo, muestra su nombre y tamaño;
// si no, muestra el texto de invitación (ej. "+ Subir nuevo archivo").
//
// Props:
// - selectedFile: File seleccionado (o null).
// - onFileSelect: callback(File) al elegir un archivo.
// - placeholder: texto mostrado cuando no hay archivo.
// - disabled: bloquea la selección (ej. mientras se sube/elimina) y
//   atenúa el componente en tonos grises.
const FileDropzone = ({
  selectedFile,
  onFileSelect,
  placeholder = '+ Subir nuevo archivo',
  disabled = false,
}) => {
  const inputRef = useRef(null);

  const openPicker = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  const handleChange = e => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) {
      onFileSelect?.(file);
    }
  };

  // Estilos del contenedor según el estado.
  const stateClasses = disabled
    ? 'cursor-not-allowed border-muted-foreground/25 bg-muted opacity-70'
    : selectedFile
    ? 'border-primary/40 bg-primary/5 hover:border-primary/50'
    : 'border-primary/25 hover:border-primary/50 hover:bg-background';

  return (
    <>
      <button
        type='button'
        onClick={openPicker}
        disabled={disabled}
        className={`flex w-full flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed px-4 text-center transition duration-150 ${
          selectedFile ? 'py-8' : 'py-4'
        } ${stateClasses}`}>
        {selectedFile ? (
          <>
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                disabled
                  ? 'bg-muted-foreground/10 text-muted-foreground'
                  : 'bg-primary/10 text-primary'
              }`}>
              <DescriptionOutlinedIcon />
            </span>
            <span
              className={`font-semibold ${disabled ? 'text-muted-foreground' : 'text-primary'}`}>
              {selectedFile.name}
            </span>
          </>
        ) : (
          <span className='font-medium text-muted-foreground'>{placeholder}</span>
        )}
      </button>
      <input
        ref={inputRef}
        type='file'
        accept='application/pdf'
        className='hidden'
        onChange={handleChange}
        disabled={disabled}
      />
    </>
  );
};

export default FileDropzone;
